import { GET_COMPANY_NEWS_SUCCESS } from 'actions';
import { Model, ModelType, attr, fk } from 'redux-orm';

interface INews {
  id: string;
  url: string;
  companyId: string;
  name: string;
  image: string;
  description: string;
  category: string;
  datePublished: string;
}

class News extends Model<typeof News, INews> {
  name!: string;

  static reducer(action: any, model: ModelType<News>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_COMPANY_NEWS_SUCCESS:
        action.data.map((d: INews) =>
          model.upsert({ ...d, companyId: action.id }),
        );
        break;
    }

    return undefined;
  }

  toString() {
    return this.name;
  }

  toViewModel() {
    return {
      ...this.ref,
    };
  }
}

News.modelName = 'News';

News.fields = {
  id: attr(),
  companyId: fk('Company'),
  name: attr(),
  image: attr(),
  description: attr(),
  category: attr(),
  datePublished: attr(),
  url: attr(),
};

export type NewsViewModel = ReturnType<News['toViewModel']>;

export default News;
